import { Button } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import AnalyticsService from '../../../services/AnalyticsService';
import InvoiceDetailsStore from '../../../stores/InvoiceDetailsStore';
import { Transaction } from '../../../stores/models/Transaction';
import PaymentHistoryStore from '../../../stores/PaymentHistoryStore';
import { ITranslateStore } from '../../../stores/TranslateStore';

interface IViewInvoiceDetailsButtonProps {
  translateStore?: ITranslateStore;
  analyticsService?: AnalyticsService;
  paymentHistoryStore?: PaymentHistoryStore;
  invoiceDetailsStore?: InvoiceDetailsStore;
  index: number;
  transaction: Transaction;
}

@inject('translateStore', 'analyticsService', 'paymentHistoryStore', 'invoiceDetailsStore')
@observer
export default class ViewInvoiceDetailsButton extends React.Component<IViewInvoiceDetailsButtonProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    const store = this.props.paymentHistoryStore;

    return (
      <Button
        text={translate('payment-history.transactions.view-invoice')}
        id={`payment-history-invoice-view-invoice-button-${this.props.index}`}
        onClick={() => {
          this.props.invoiceDetailsStore.activateInvoiceDetails(store.toInvoiceDetailsRequest(this.props.transaction), 'payment history');
        }}
        size="small"
        type="primary"
      />
    );
  }
}
